import React, {Fragment} from "react";
import { connect } from "react-redux";
import {LOOK_OVERLAYS} from "../../core/constants";
import WithOverlay from "../../../popups/withOverlayHoc";
import LookIntroBox from "./lookIntroBox";
// import LookDemoPoints from "../../demoPoints/lookDemoPoints";
import LookCanvasContext from "../../lookCanvasContext";
import LookIntroCanvasHighlighting from "./lookIntroCanvasHighlighting";


const LookIntro = (props) => {

  // const {lookOverlayOpened, introStep, introHidden, isMobile} = props;
  const {lookOverlayOpened} = props;

  if (lookOverlayOpened !== LOOK_OVERLAYS.intro) {
    return null
  }

  return (
    <Fragment>
      <WithOverlay>
        {(hideOverlay) => (
          <LookIntroBox hideOverlay={hideOverlay}/>
        )}
      </WithOverlay>
      <LookCanvasContext.Consumer>
        {(imageCanvas) => (
          <Fragment>
            {/*<LookDemoPoints isIntro={true}*/}
            {/*                imageCanvas={imageCanvas}*/}
            {/*                introStep={introStep}*/}
            {/*                introHidden={introHidden}*/}
            {/*                isMobile={isMobile}*/}
            {/*                showPoints={introStep === LOOK_INTRO_STEPS.wallsAndFloor}/>*/}
            <LookIntroCanvasHighlighting imageCanvas={imageCanvas}/>
          </Fragment>
        )}
      </LookCanvasContext.Consumer>
    </Fragment>
  )
};

const mapStateToProps = (store) => {
  // const {introStep, lookOverlayOpened, introHidden} = store.lookState;
  const {lookOverlayOpened} = store.lookState;
  const {canvasDimensions} = store.bathroomVisualizerState;
  const {windowWidth, windowHeight} = store.serverState;
  return {
    lookOverlayOpened,
    // introStep,
    // introHidden,
    canvasDimensions,
    windowWidth,
    windowHeight,
    // isMobile,
  };
};

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(LookIntro)
